export function attachRootDomains(websites) {
  websites.normalizeRootDomain = function (value) {
    if (!value) return "";
    return value
      .toString()
      .trim()
      .toLowerCase()
      .replace(/^https?:\/\//, "")
      .replace(/^www\./, "")
      .replace(/[/?#].*$/, "")
      .replace(/:\d+$/, "")
      .replace(/\s+/g, "");
  };

  websites.rootDomainsLimit = function () {
    var limitAttr = $("#root-domains-settings").attr("data-limit");
    if (limitAttr === "unlimited") {
      return Infinity;
    }
    var limit = parseInt(limitAttr, 10);
    return isNaN(limit) ? 1 : limit;
  };

  websites.rootDomainsPrimaryLocked = function () {
    return $("#root-domains-settings").attr("data-primary-locked") === "true";
  };

  websites.rootDomainPills = function () {
    return $("#root-domains-pills .root-domain-pill");
  };

  websites.currentRootDomains = function () {
    return websites
      .rootDomainPills()
      .map(function () {
        return websites.normalizeRootDomain(
          $(this).find(".root-domain-input").val()
        );
      })
      .get()
      .filter(Boolean);
  };

  websites.appendRootDomainPill = function (value) {
    var template = document.getElementById("root-domain-pill-template");
    if (!template) return;

    var normalized = websites.normalizeRootDomain(value);
    if (!normalized) return;
    if (websites.currentRootDomains().indexOf(normalized) !== -1) return;

    var clone = template.content.cloneNode(true);
    var el = clone.querySelector(".root-domain-pill");
    if (!el) return;

    var $pill = $(el);
    $pill.find(".root-domain-input").val(normalized);
    $pill.find(".root-domain-label").text(normalized);
    $pill
      .find(".remove-root-domain")
      .attr("aria-label", "Remove " + normalized);
    $("#root-domain-composer").before($pill);
  };

  websites.refreshRootDomainPills = function () {
    var primaryLocked = websites.rootDomainsPrimaryLocked();
    websites.rootDomainPills().each(function (index) {
      var isLocked = primaryLocked && index === 0;
      var $pill = $(this);
      var domain = websites.normalizeRootDomain(
        $pill.find(".root-domain-input").val()
      );
      $pill.attr("data-index", index);
      $pill.attr("data-locked", isLocked ? "true" : "false");
      $pill.toggleClass("root-domain-primary", isLocked);
      $pill.find(".root-domain-lock").toggle(isLocked);
      $pill.find(".remove-root-domain").toggle(!isLocked);
      if (domain) {
        $pill
          .find(".remove-root-domain")
          .attr("aria-label", "Remove " + domain);
      }
    });

    var limit = websites.rootDomainsLimit();
    var atLimit = websites.rootDomainPills().length >= limit;
    $("#root-domain-composer").prop("disabled", atLimit);
  };

  websites.addRootDomainFromComposer = function () {
    var $composer = $("#root-domain-composer");
    var value = websites.normalizeRootDomain($composer.val());
    if (!value) {
      $composer.val("");
      return;
    }

    var limit = websites.rootDomainsLimit();
    var count = websites.rootDomainPills().length;
    var primaryLocked = websites.rootDomainsPrimaryLocked();
    var primary = websites.normalizeRootDomain($("#website_name").val());
    var willSeedPrimary =
      primaryLocked && count === 0 && primary && value !== primary;

    if (count + (willSeedPrimary ? 2 : 1) > limit) {
      alert(
        "Your website has reached your plan's maximum of " +
          limit +
          " root domain" +
          (limit === 1 ? "" : "s") +
          "."
      );
      return;
    }

    if (willSeedPrimary) {
      websites.appendRootDomainPill(primary);
    }

    websites.appendRootDomainPill(value);
    $composer.val("");
    websites.refreshRootDomainPills();
  };

  websites.initializeRootDomains = function () {
    if ($("#root-domains-settings").length === 0) return;

    $("#root-domain-composer")
      .off("keydown.rootDomains")
      .on("keydown.rootDomains", function (e) {
        if (e.key === "Enter" || e.key === ",") {
          e.preventDefault();
          websites.addRootDomainFromComposer();
          return;
        }

        if (e.key === "Backspace" && !$(this).val()) {
          var $last = websites.rootDomainPills().last();
          if ($last.length && $last.attr("data-locked") !== "true") {
            $last.find(".remove-root-domain").click();
          }
        }
      })
      .off("blur.rootDomains")
      .on("blur.rootDomains", function () {
        websites.addRootDomainFromComposer();
      });

    $("#root-domains-pills")
      .off("click.rootDomains", ".remove-root-domain")
      .on("click.rootDomains", ".remove-root-domain", function (e) {
        e.preventDefault();
        var $pill = $(this).closest(".root-domain-pill");
        if ($pill.attr("data-locked") === "true") return;
        $pill.remove();
        websites.refreshRootDomainPills();
      });

    $("#website_name")
      .off("input.rootDomains keyup.rootDomains")
      .on("input.rootDomains keyup.rootDomains", function () {
        if (!websites.rootDomainsPrimaryLocked()) return;
        var primary = websites.normalizeRootDomain($(this).val());
        var $primary = $(".root-domain-pill.root-domain-primary").first();
        $primary.find(".root-domain-input").val(primary);
        $primary.find(".root-domain-label").text(primary);
      });

    websites.refreshRootDomainPills();
  };
}

export default attachRootDomains;
